"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debugTool;
// AlminPerfMarker will not loaded in production
if (process.env.NODE_ENV !== "production") {
    var AlminPerfMarker = require("./AlminPerfMarker").AlminPerfMarker;
    debugTool = new AlminPerfMarker();
}
exports.default = { debugTool: debugTool };
//# sourceMappingURL=AlminInstruments.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/instrument/AlminInstruments.js
// module id = 192
// module chunks = 0